import React from "react";
import { apiCall } from "../common/common";
import { displayLog } from "../common/common";

//config
import config from "../config";
import Axios from "axios";

const SubscribersContext = React.createContext();

const rootReducer = (state, action) => {
    switch (action.type) {
        case "GET_SUBSCRIBER_DATA":
            return {
                isLoaded: true,
                SubscriberUser: action.payload.data,
            };
        case "REQUEST_CALLED":
            return {
                isLoaded: false,
                SubscriberUser: [],
            };
        default:
            return {
                ...state,
            };
    }
};

const SubscriberUsersProvider = ({ children }) => {
    const [SubscriberUser, setSubscriberUser] = React.useReducer(rootReducer, {
        isLoaded: false,
        SubscriberUser: [],
    });

    return (
        <SubscribersContext.Provider
            value={{ SubscriberUser, setSubscriberUser, }}
        >
            {children}
        </SubscribersContext.Provider>
    );
};

const useSubscriberUserState = () => {
    const context = React.useContext(SubscribersContext);
    return context;
};

//API call to set Help content
export const getSubscribersDatas = async (dispatch, reqData) => {
    dispatch({ type: "REQUEST_CALLED" });
    let response = await apiCall(
        "POST",
        "GET_SUBSCRIBER_DATA",
        "/admin/getSubscribedUserList",
        reqData,
        {},
        {},
        dispatch
    );
    // console.log("REPSONSE ----------------------", response?.data)
    if (response && response.data) {
        if (response.data.code === 0) {
            displayLog(0, response.data.message);
        } else {
            dispatch({ type: "GET_SUBSCRIBER_DATA", payload: response.data });
        }
    }
};

export { SubscriberUsersProvider, SubscribersContext, useSubscriberUserState };
